import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class QuestionService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  getQuestion (qcid:number,eid:number,lid:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/question/question_all/'+ qcid + '/'+ eid + '/' + lid, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('question_all', []))
      );
  }
  getQuestionList (qcid:number,lid:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/question/question_list_all/' + qcid + '/' + lid, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('question_list', []))
      );
  }
  getSpecialCheckUPList(id:number){
    var uri:string;
    this.commonService.loadingStart();
    if (id==6){
      uri = 'chemical_substance_list';
    }else{
      uri = 'organic_solvent_list';
    }
    return this.http.get(environment.apiUrl+'/api/question/'+uri, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('getSpecialCheckUPList', []))
      );
  }
  save (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/question/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveQ', []))
      );
  }
  update (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/question/update',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateQ', []))
      );
  }
  changeOrder (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/question/change_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateQ', []))
      );
  }

  delete (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/question/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteQ', []))
      );
  }
  copy (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/question/copy',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('copyQ', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/question.service.ts